module.exports = __webpack_public_path__ + "nc_static/media/merck-log-color.a828b23c.png";